__turbopack_context__.v({
  "backButton": "page-module__VvzSyW__backButton",
  "ctaArrow": "page-module__VvzSyW__ctaArrow",
  "fadeInUp": "page-module__VvzSyW__fadeInUp",
  "footer": "page-module__VvzSyW__footer",
  "footerBrand": "page-module__VvzSyW__footerBrand",
  "footerContent": "page-module__VvzSyW__footerContent",
  "footerDivider": "page-module__VvzSyW__footerDivider",
  "footerLinks": "page-module__VvzSyW__footerLinks",
  "footerLogo": "page-module__VvzSyW__footerLogo",
  "footerTagline": "page-module__VvzSyW__footerTagline",
  "hero": "page-module__VvzSyW__hero",
  "heroContent": "page-module__VvzSyW__heroContent",
  "heroCta": "page-module__VvzSyW__heroCta",
  "heroNote": "page-module__VvzSyW__heroNote",
  "heroSubtitle": "page-module__VvzSyW__heroSubtitle",
  "heroTitle": "page-module__VvzSyW__heroTitle",
  "heroTitleLine": "page-module__VvzSyW__heroTitleLine",
  "howItWorksSection": "page-module__VvzSyW__howItWorksSection",
  "loading": "page-module__VvzSyW__loading",
  "main": "page-module__VvzSyW__main",
  "quizBranding": "page-module__VvzSyW__quizBranding",
  "quizHeader": "page-module__VvzSyW__quizHeader",
  "quizLogo": "page-module__VvzSyW__quizLogo",
  "quizSection": "page-module__VvzSyW__quizSection",
  "sectionContainer": "page-module__VvzSyW__sectionContainer",
  "sectionSubtitle": "page-module__VvzSyW__sectionSubtitle",
  "sectionTitle": "page-module__VvzSyW__sectionTitle",
  "segmentCard": "page-module__VvzSyW__segmentCard",
  "segmentCta": "page-module__VvzSyW__segmentCta",
  "segmentDescription": "page-module__VvzSyW__segmentDescription",
  "segmentIcon": "page-module__VvzSyW__segmentIcon",
  "segmentTitle": "page-module__VvzSyW__segmentTitle",
  "segmentsGrid": "page-module__VvzSyW__segmentsGrid",
  "segmentsSection": "page-module__VvzSyW__segmentsSection",
  "step": "page-module__VvzSyW__step",
  "stepContent": "page-module__VvzSyW__stepContent",
  "stepDescription": "page-module__VvzSyW__stepDescription",
  "stepNumber": "page-module__VvzSyW__stepNumber",
  "stepTime": "page-module__VvzSyW__stepTime",
  "stepTitle": "page-module__VvzSyW__stepTitle",
  "stepsContainer": "page-module__VvzSyW__stepsContainer",
  "trustBadge": "page-module__VvzSyW__trustBadge",
  "trustBadges": "page-module__VvzSyW__trustBadges",
  "trustContent": "page-module__VvzSyW__trustContent",
  "trustCta": "page-module__VvzSyW__trustCta",
  "trustSection": "page-module__VvzSyW__trustSection",
  "trustSubtitle": "page-module__VvzSyW__trustSubtitle",
  "trustTitle": "page-module__VvzSyW__trustTitle",
});
